import React from "react";
import { Stack as MUIStack } from "@mui/material";
import styled from "styled-components";

const StyledStack = styled(MUIStack)``;

/**
 * A component that renders a stack of elements with customizable spacing, direction, and alignment.
 *
 * @component
 * @param {number} spacing - The spacing between each child element. Default is 2.
 * @param {string} direction - The direction of the stack. Can be "row" or "column". Default is "row".
 * @param {string} alignment - The alignment of the stack items. Can be "start", "center", "end", or "stretch". Default is "center".
 * @param {ReactNode} children - The child elements to be rendered within the stack.
 * @returns {JSX.Element} The rendered stack component.
 */
export const Stack = ({
  spacing = 2,
  direction = "row",
  alignment = "center",
  children,
}) => {
  return (
    <StyledStack spacing={spacing} direction={direction} alignItems={alignment}>
      {children}
    </StyledStack>
  );
};
